<template>
  <!-- 支出结算 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
           <div class="gjhBox">
            <el-form-item label="业务编号:" prop="businessNo">
              <el-input  placeholder=""   type="textarea" v-model="searchFrom.businessNoss" class="gjh"></el-input>
            </el-form-item>
            <el-form-item label="订单编号:" prop="orderNoss">
              <el-input  placeholder=""   type="textarea" v-model="searchFrom.orderNoss" class="gjh"></el-input>
            </el-form-item>

          </div>
            <div class="item">
              <el-form-item label="付款状态:" prop="settlementStatusS">
                <el-select  v-model="searchFrom.settlementStatusS"  placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待付款" value="1301"></el-option>
                  <el-option label="付款中" value="1302"></el-option>
                  <el-option label="已付款" value="1303"></el-option>
                  <el-option label="付款失败" value="1401"></el-option>
                  <el-option label="圈回中" value="1501"></el-option>
                  <el-option label="清分中" value="[1304,1305]"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="付款账户名称:" prop="platformZxAccNm">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNm"></el-input>
              </el-form-item>
              <el-form-item label="付款账号:" prop="platformZxAccNo">
                <el-input  placeholder="" v-model="searchFrom.platformZxAccNo"></el-input>
              </el-form-item>
              <el-form-item label="提现状态:" prop="withdrawalStatus">
                <el-select  v-model="searchFrom.withdrawalStatus"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未提现" value="1"></el-option>
                  <el-option label="提现中" value="2"></el-option>
                  <el-option label="已提现" value="3"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="收款方类型:" prop="settlementType">
                <el-select  v-model="searchFrom.settlementType"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="车队" value="1"></el-option>
                  <el-option label="司机" value="2"></el-option>
                  <el-option label="车队长" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收款方:" prop="settlementName">
                <el-input  placeholder="" v-model="searchFrom.settlementName"></el-input>
              </el-form-item>
              <el-form-item label="订单类型" prop="periodFlag">
                  <el-select  v-model="searchFrom.periodFlag"   placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="普通货源" value="0"></el-option>
                    <el-option label="长期货源" value="1"></el-option>
                  </el-select>
                </el-form-item>
              <el-form-item label="付款时间:" prop="settlementTimes">
                <el-date-picker
                  v-model="searchFrom.settlementTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="是否推送T+:" prop="tPlusId">
                <el-select  v-model="searchFrom.tPlusId" placeholder="请选择">
                  <!-- 0是 1否 -->
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" value="0"></el-option>
                  <el-option label="否" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提现时间:" prop="withdrawalTime">
                <el-date-picker
                  v-model="searchFrom.withdrawalTimes"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item   btnCode="00JP003B001" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JP003B002" v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JP003B004" v-if="btnFlg[3]">
            <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fukuanFnzz" v-if="btnFlg[8]">批量支付</el-button>
          </el-form-item>
          <el-form-item  btnCode="00JM030300" v-if="btnFlg[9]">
            <el-button type="primary" @click="tuiSong">推送T+</el-button>
          </el-form-item>
            <el-form-item>
           <p class="margin0">应付合计：<span class="red">{{shouruData.total}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">已付合计：<span class="red">{{shouruData.alreadytotal}}</span>元</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">未付合计：<span class="red">{{shouruData.wTotal}}</span>元</p>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <!-- :row-key="getRowKeys" -->
      <el-table
        :data="tableList"
        ref="table"
        v-loading="loading"
        bordersize="mini"
        @selection-change='selectGoods'
        height="100%" style="width: 100%" center border>
        <!-- :reserve-selection="true"   翻页记忆 -->
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <div>
              <!-- <el-button type="text"  size="mini"   @click="fukuanFn(scope.row)" btnCode="00JP003B003" v-if="btnFlg[2]&&scope.row.settlementStatus==1301" >支付</el-button> -->
              <el-button type="text"  size="mini"   @click="fukuanFn(scope.row,1)" btnCode="00JP003B003" v-if="btnFlg[2]&&scope.row.settlementStatus==1301&&scope.row.settlementType!==2" >支付</el-button>
              <el-button type="text"  size="mini"   @click="fukuanFn(scope.row,2)" btnCode="00JP003B003" v-if="btnFlg[2]&&(scope.row.settlementStatus==1301||scope.row.settlementStatus==1401)&&scope.row.settlementType==2&&scope.row.payType==1" >支付</el-button>
              <el-button type="text"  size="mini"   @click="tiaojiaFn(scope.row)"  v-if="btnFlg[4]&&scope.row.settlementStatus==1301" >调价</el-button>
              <el-button type="text" size="mini"  @click="jiluFn(scope.row)"  v-if="btnFlg[5]&&scope.row.isPrice==1">记录</el-button>
              <!-- <span v-if="scope.row.settlementStatus==1303">-</span> -->
              <el-button type="text" size="mini" v-if ="btnFlg[6]&&scope.row.withdrawalStatus == 3"  @click="huidanFn(scope.row)">银行回单</el-button>
              <el-button type="text" size="mini"  @click="recallFn(scope.row)"  v-if="btnFlg[7]&&scope.row.settlementStatus==1303&&scope.row.withdrawalStatus==1&&scope.row.payType==1">圈回</el-button>
              </div>
            </template>
          </el-table-column>
         <el-table-column label="业务单号"  width="200">
            <template slot-scope="scope">
              <span style="color: #0e6eec;cursor: pointer;" @click="seeClickNO(scope.row)">{{scope.row.businessNo}}</span>
            </template>
        </el-table-column>
        <el-table-column width="200" property="orderNo"  :formatter="emptyFn" label="订单编号"></el-table-column>
        <el-table-column property="periodFlag" label="订单类型" width="100">
          <template scope="scope">{{[ "普通货源","长期货源" ][scope.row.periodFlag]}}</template>
        </el-table-column>
        <el-table-column property="settlementStatus" label="付款状态">
          <template scope="scope">
            <div>
            <span style="color:red" v-if="scope.row.settlementStatus==1301">待付款</span>
            <span v-if="scope.row.settlementStatus==1302">付款中</span>
            <span v-if="scope.row.settlementStatus==1303">已付款</span>
            <span v-if="scope.row.settlementStatus==1401">付款失败</span>
            <span v-if="scope.row.settlementStatus==1501">圈回中</span>
            <span v-if="scope.row.settlementStatus==1304 || scope.row.settlementStatus==1305||scope.row.settlementStatus==1306||scope.row.settlementStatus==1307">清分中</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="payType" label="支付方式">
         <template scope="scope">
          <div>
            <span>{{scope.row.payType?[ "线上支付","线下支付"][scope.row.payType-1]:'-'}}</span>
          </div>
         </template>
        </el-table-column>
        <el-table-column width="320" property="platformZxAccNm"  :formatter="emptyFn" label="付款账户名称"></el-table-column>
        <el-table-column width="200" property="platformZxAccNo"  :formatter="emptyFn" label="付款账号"></el-table-column>
         <el-table-column property="publishPricingMethod" label="提现状态">
          <template scope="scope"><div>{{[ "未提现", "提现中","已提现",][scope.row.withdrawalStatus-1]}}</div></template>
        </el-table-column>
          <el-table-column property="shipperTenantName"  width="270"  :formatter="emptyFn" label="货主名称"></el-table-column>
          <el-table-column property="settlementType" width="120" label="收款方类型">
          <template scope="scope">{{[ "车队", "司机","车队长"][scope.row.settlementType-1]}}</template>
        </el-table-column>
          <el-table-column property="settlementName"  width="200"  :formatter="emptyFn"   label="收款方"></el-table-column>
        <el-table-column property="weight"  width="120"  :formatter="emptyFn"   label="结算量"></el-table-column>
         <el-table-column property="publishPricingMethod" label="计价方式">
          <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
        </el-table-column>
        <el-table-column property="unitPrice" width="100" label="单价">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="应付合计(元)"  width="120">
            <template slot-scope="scope">
              <span style="color: #0e6eec;cursor: pointer;" @click="YFHJfn(scope.row)">{{scope.row.totalAmount}}</span>
            </template>
        </el-table-column>
         <el-table-column property="tPlusId" label="是否推送T+" width="120">
          <template scope="scope">
             <div>
              <!-- tPlusId有值已推送  null未推送 -->
              <span v-if="scope.row.tPlusId">是</span>
              <span v-else>否</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="170" property="settlementTime" :formatter="dateTimeFormat" label="付款时间"></el-table-column>
        <el-table-column width="170" property="withdrawalTime" :formatter="dateTimeFormat" label="提现时间"></el-table-column>
        <el-table-column width="170" property="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 付款 -->
    <el-dialog  title="付款"  :visible.sync="fukuanMark" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="fukuanFrom" :rules="rules" ref="fukuanFrom" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
             <div style="display: flex;justify-content: space-between; ">
                <p>应付合计:<span style="color:red;font-size:18px">{{fukuanFrom.totalAmount}}</span>元</p>
                <p>平台账户:<span >{{fukuanFrom.ext1}}</span>元</p>
             </div>
             <div style="text-align: center; margin: 28px 0;">
               <el-form-item prop="password" label="支付密码:">
                  <el-input
                    v-model="fukuanFrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fukuanMark = false">取消</el-button>
        <el-button type="primary" @click="ZFsavezz()">支付</el-button>
      </span>
   </el-dialog>
   <!-- 调价 -->
    <el-dialog  title="调价"  :visible.sync="tiaojiaMark" width="400px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="tiaojiaFrom" ref="tiaojiaFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
               <el-form-item prop="weight" label="验收量:">
                 <span>{{tiaojiaFrom.weight}}</span>
                </el-form-item>
                <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
                  <el-select  v-model="tiaojiaFrom.pricingMethod"  placeholder="请选择"  >
                    <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="单价:" class="jiage" prop="unitPrice" v-if="tiaojiaFrom.pricingMethod==1" >
                  <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="tiaojiaFrom.unitPrice"  ></el-input><span class="danwei">元/{{tiaojiaFrom.unitMeasurement}}</span>
                </el-form-item>
                 <el-form-item label="包干价:" class="jiage" prop="unitPrice"  v-if="tiaojiaFrom.pricingMethod==2">
                  <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="tiaojiaFrom.unitPrice"  ></el-input>
                </el-form-item>
                 <el-form-item prop="totalAmount" label="运费:">
                  <div style="width:150px">{{tiaojiaFrom.totalAmount}}元</div>
                </el-form-item>
                <el-form-item prop="reason" label="调价原因:">
                  <el-input type="textarea"  :rows="4"  placeholder=""  maxlength="500" v-model="tiaojiaFrom.reason"></el-input>
                </el-form-item>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tiaojiaMark = false">取消</el-button>
        <el-button type="primary" @click="TJsave()">确定</el-button>
      </span>
   </el-dialog>
    <!-- 调价记录 -->
    <el-dialog  title="调价记录"  :visible.sync="jiluMark" width="800" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div>
        <div v-for="item in jiluList" :key="item.id">
            <div class="table">
              <div style=" display: flex;justify-content: space-between;">
                 <p style="font-size：18px;font-weight: bold;">调价前</p>
                  <p>调价时间：{{item.createTime|dateFormat}}</p>
              </div>
              <el-table :data="item.tableList" v-loading="loading"  bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
                <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
                <el-table-column property="publishPricingMethod" label="计价方式">
                  <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
                </el-table-column>
                <el-table-column property="unitPrice" width="100"     label="单价">
                  <template scope="scope">
                    <div>
                    <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{unitMeasurement}}</span>
                    <span v-if="scope.row.pricingMethod==2">-</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="结算量" align="center">
                  <template slot-scope="scope">
                  <span>{{scope.row.weight}}{{unitMeasurement}}</span>
                </template>
                </el-table-column>
                <el-table-column property="actualFatePrice"  width="120"  :formatter="emptyFn"   label="运费(元)"></el-table-column>
                <el-table-column property="actualTaxation"  width="120"  :formatter="emptyFn"   label="服务费(元)"></el-table-column>
                <el-table-column property="actualTotalAmount"  width="120"  :formatter="emptyFn"   label="应付合计(元)"></el-table-column>
              </el-table>
          </div>
          <div style="border-bottom: 1px dashed #ddd; margin-top: 25px;" v-if="jiluList.length>0">
              <p>操作人员：{{item.createUserName}}</p>
              <p>调价原因：{{item.reason}}</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="jiluMark = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 应付合计 -->
    <el-dialog  title="应付合计"  :visible.sync="HJmark" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div>
        <div>
          <p>实付合计: <span style="color:red;font-size:18px">{{fukuanFrom.totalAmount}}</span>元</p>
        </div>
        <div class="table">
            <el-table :data="MXlist"  ref="MXlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
              <el-table-column property="feeType" label="费目">
                <template scope="scope">{{[ "运费", "服务费","押金","代扣税费","油气费"][scope.row.feeType-1]}}</template>
              </el-table-column>
              <el-table-column property="feeStatus" label="状态">
                <template scope="scope">{{[ "待付款", "已付款",][scope.row.feeStatus-1]}}</template>
              </el-table-column>
             <el-table-column property="feeStatus" label="金额(元)">
                <template scope="scope">
                  <div>
                  <!-- <span v-if="scope.row.feeType!=4">{{scope.row.amount}}</span> -->
                  <span v-if="scope.row.feeType!=4&&scope.row.feeType!=5">{{scope.row.amount}}</span>
                  <el-button type="text"  size="mini"   @click="shuifeiFn(scope.row)" v-if="scope.row.feeType==4" >{{scope.row.amount}}</el-button>
                  <el-button type="text"  size="mini"   @click="oliFeeFn(scope.row)" v-if="scope.row.feeType==5" >{{scope.row.amount}}</el-button>
                 </div>
                  </template>
              </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="HJmark = false">关闭</el-button>
      </span>
      <el-dialog  title="代扣税费明细"  :visible.sync="dialogSF" width="600"  append-to-body   :close-on-click-modal="false" :close-on-press-escape="false" center>
          <div class="table">
            <el-table :data="SFlist"  ref="SFlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
              <el-table-column property="taxReimbursement"  width="120"  :formatter="emptyFn"   label="个人所得税"></el-table-column>
              <el-table-column property="valueAddedTax"  width="120"  :formatter="emptyFn"   label="增值税"></el-table-column>
              <el-table-column property="urbanConstructionTax"  width="120"  :formatter="emptyFn"   label="城建税"></el-table-column>
              <el-table-column property="educationSurtax"  width="120"  :formatter="emptyFn"   label="教育附加费"></el-table-column>
              <el-table-column property="localEducationSurtax"  width="120"  :formatter="emptyFn"   label="地方教育附加"></el-table-column>
              <el-table-column property="stampDuty"  :formatter="emptyFn"   label="印花税"></el-table-column>
          </el-table>
        </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogSF = false">关闭</el-button>
          </span>
      </el-dialog>
      <el-dialog  title="油气费明细"  :visible.sync="dialogOli" width="600"  append-to-body   :close-on-click-modal="false" :close-on-press-escape="false" center>
          <div class="table">
            <el-table :data="oliList"  ref="oliList" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
              <el-table-column property="oldTotalPay"  min-width="120"  :formatter="emptyFn"   label="原应付合计"></el-table-column>
              <el-table-column property="oilGasRatio"  min-width="120"  :formatter="emptyFn"   label="油气比例">
                <template scope="scope">
                  <div>
                    {{scope.row.oilGasRatio ? scope.row.oilGasRatio*100 + '%': '-'}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="allocationAmount"  min-width="120"  :formatter="emptyFn"   label="分配金额"></el-table-column>
              <el-table-column property="rewardAmount"  min-width="120"  :formatter="emptyFn"   label="奖励金额"></el-table-column>
              <el-table-column property="amount"  min-width="120"  :formatter="emptyFn"   label="实付油费"></el-table-column>
          </el-table>
        </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogOli = false">关闭</el-button>
          </span>
      </el-dialog>

   </el-dialog>
    <!-- 订单详情 -->
    <orderDetail :rowData="row"  v-if="orderDetilFlag"  @destroy="destroy"></orderDetail>
    <!-- 圈回 -->
    <el-dialog title="提示"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recallMark"
    width="500px"
    center>
      <div>
        <span style="text-align: center;display:block;margin-top:20px">您确定要圈回本单所有已支付费用么?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recallMark = false">取 消</el-button>
        <el-button type="primary" @click="recallSave">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 支付油气 -->
    <!-- <el-dialog  title="支付"  :visible.sync="oilgasMark" width="700px"  :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" center>
       <el-form :inline="true"  autocomplete="off" :model="fukuanFrom" :rules="rules" ref="fukuanFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
          <div>
               <div style="display: flex;justify-content: space-between; margin-left:10px">
                <p>应付合计: <span style="color:red;font-size:18px">{{fukuanFrom.wayAmount}}</span>元</p>
              </div>
              <div style="display: flex;">
                <el-form-item label="油气比例:" prop="oilGasRatio" class="jiage" label-width="82px">
                  <el-input placeholder=""  v-number-input.float="1"  maxlength="8" v-model="fukuanFrom.oilGasRatio" @blur="oilgasChange" ></el-input><span class="danwei1">%</span>
                </el-form-item>
                <el-form-item label="奖励金额:" prop="rewardAmount" class="jiage"  label-width="177px" >
                  <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="fukuanFrom.rewardAmount" type="text" autocomplete="off"   :readonly="readonlyInput" @focus="cancelReadOnly()">></el-input><span class="danwei1">元</span>
                </el-form-item>
              </div>
          </div>
          <el-divider></el-divider>

            <div style="display: flex;justify-content: space-between">
              <div style="width:310px">
                <el-form-item label="实付油气费:" label-width="97px">
                  <span style="font-size:14px；display:block;"><span style="color:red;font-size:18px">{{addUp1|numFormat(2)}}元</span> / 余额{{balance}}元</span>
                </el-form-item>
              </div>
              <div style="width:350px">
                <el-form-item label="实付运费:" >
                  <span style="font-size:14px; display:block;"><span style="color:red;font-size:18px">{{fukuanFrom.oilGasRatio==0 ? fukuanFrom.wayAmount : addUp2|numFormat(2)}}元</span> / 余额{{fukuanFrom.ext1}}元</span>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="实付合计:" label-width="83px">
              <span style="font-size:14px"><span style="color:red;font-size:18px">{{(fukuanFrom.oilGasRatio==0 && fukuanFrom.rewardAmount==0) ? fukuanFrom.wayAmount :addUp3|numFormat(2)}}元</span></span>
            </el-form-item>

             <div style="text-align: center; margin: 5px 0;">
               <el-form-item prop="password" label="支付密码:" >
                  <el-input
                    autocomplete="off"
                    :readonly="readonlyInput"
                    @focus="cancelReadOnly()"
                    type="text"
                    v-model="fukuanFrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="oilgasMark = false">取消</el-button>
        <el-button type="primary" @click="oilgassave()">支付</el-button>
      </span>
   </el-dialog> -->
    <el-dialog  title="支付"  :visible.sync="oilgasMark" width="750px"  :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" center>
       <el-form :inline="true"  autocomplete="off" :model="fukuanFrom" :rules="rules" ref="fukuanFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
          <div>
               <div style="display: flex;justify-content: space-between; margin-left:36px">
                <p>应付合计: <span style="color:red;font-size:18px">{{fukuanFrom.wayAmount}}</span>元</p>
              </div>
              <div style="display: flex;">
                <!-- <el-form-item label="油气比例:" prop="oilGasRatio" class="jiage" label-width="107px">
                  <el-input placeholder=""  v-number-input.float="1"  maxlength="8" v-model="fukuanFrom.oilGasRatio" @blur="oilgasChange" ></el-input><span class="danwei1">%</span>
                </el-form-item>
                <el-form-item label="奖励金额:" prop="rewardAmount" class="jiage"  label-width="202px" >
                  <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="fukuanFrom.rewardAmount" type="text" autocomplete="off"   :readonly="readonlyInput" @focus="cancelReadOnly()">></el-input><span class="danwei1">元</span>
                </el-form-item> -->
              </div>
          </div>
          <el-divider></el-divider>

            <div style="display: flex;justify-content: space-between">
              <!-- <div style="width:350px">
                <el-form-item label="实付油气费:" label-width="123px">
                  <span style="font-size:14px；display:block;"><span style="color:red;font-size:18px">{{addUp1|numFormat(2)}}元</span> / 余额{{balance}}元</span>
                </el-form-item>
              </div> -->
              <div style="width:350px">
                <el-form-item label="实付运费:" >
                  <span style="font-size:14px; display:block;"><span style="color:red;font-size:18px">{{fukuanFrom.oilGasRatio==0 ? fukuanFrom.wayAmount : addUp2|numFormat(2)}}元</span> / 余额{{fukuanFrom.ext1}}元</span>
                </el-form-item>
              </div>
            </div>
            <el-form-item label="实付合计:" label-width="110px">
              <span style="font-size:14px"><span style="color:red;font-size:18px">{{(fukuanFrom.oilGasRatio==0 && fukuanFrom.rewardAmount==0) ? fukuanFrom.wayAmount :addUp3|numFormat(2)}}元</span></span>
            </el-form-item>

             <div style="text-align: center; margin: 5px 0;">
               <el-form-item prop="password" label="支付密码:" >
                  <el-input
                    autocomplete="off"
                    :readonly="readonlyInput"
                    @focus="cancelReadOnly()"
                    type="text"
                    v-model="fukuanFrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="oilgasMark = false">取消</el-button>
        <el-button type="primary" @click="oilgassave()">支付</el-button>
      </span>
   </el-dialog>
     <!-- 支付 -->
    <el-dialog  title="批量支付"  :visible.sync="fukuanMarkzz" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="fukuanFrom" ref="fukuanFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="100px" size="mini">
        <div class="inpBox">
             <div style="display: flex;justify-content: space-between; ">
                <p>应付合计:<span style="color:red;font-size:18px">{{fukuanFrom.allTotal}}</span>元</p>
                <p>储蓄金额:<span >{{fukuanFrom.ext1}}</span>元</p>
             </div>
             <div style="text-align: center; margin: 28px 0;display:flex;flex-direction:column">
               <el-form-item prop="password" label="支付密码:">
                  <el-input
                    v-model="fukuanFrom.password"
                    maxlength="20"
                    show-password
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fukuanMarkzz = false">取消</el-button>
        <el-button type="primary" @click="ZFsavezz()">支付</el-button>
      </span>
   </el-dialog>
    <!-- 支付状态 -->
   <el-dialog  title="支付状态"  :visible.sync="zfztMark" width="800" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
        <div class="table">
          <el-table :data="zfztList"   bordersize="mini"  :row-class-name="tableRowClassName"
            style="width: 100%" center border>
            <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
            <el-table-column property="businessNo"   :formatter="emptyFn"   label="业务编号"></el-table-column>
            <el-table-column property="zfzt"  :formatter="emptyFn"   label="支付状态"></el-table-column>
            <el-table-column property="res"   :formatter="emptyFn"   label="失败原因"></el-table-column>
          </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="zfztMark = false">关闭</el-button>
      </span>
   </el-dialog>
   <!-- 推送T+ -->
   <el-dialog title="推送T+" v-loading="tuiSongLoading" :visible.sync="tuiSongTMark" width="600px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
      <div class="table">
        <el-form ref="tuiSongForm" :inline="true" size="mini" class="demo-form-inline">
          <el-form-item label="账套名称:" style="margin-left:110px;width:380px;padding:20px 0 100px 0;">
            <el-select v-model="tuiSongForm.itemNo" clearable filterable placeholder="请选择" style="width:260px" size="mini">
              <el-option v-for="(item, index) in dicDataTms" :key="index" :label="item.showName" :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tuiSongQuXiao" >取消</el-button>
        <el-button type="primary" @click="tuiSongSubmit">确定</el-button>
      </span>
   </el-dialog>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, encryption, toFixed } from '@/utils/util'
import orderDetail from '@/views/consignment/payCustomer/settlement/orderDetail.vue'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  toPayDetail, // 余额
  downstreamSettlementList, // 列表
  downstreamSettlementDetail,
  sTaxationDetail,
  downstreamSettlementPayment,
  tModifyPriceRecordList, // 调价记录
  downstreamSettlementPric, // 调价
  recycleMoney, // 圈回
  oilDetailList, // 油气详情
  piLPaymentList
} from '@/api/consignment'
import { getDicFromTms, pushTPlusToTmsPay } from '@/api/common-signature'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
export default {
  components: {
    orderDetail
  },
  data () {
    return {
      zfztList: [], // 支付状态列表
      zfztMark: false,
      fukuanMarkzz: false,
      jiesuanID: '',
      oliList: [],
      dialogOli: false,
      balance: '',
      readonlyInput: true,
      // 油气支付
      oilgasMark: false,
      // 圈回
      recallMark: false,
      recallId: '',
      emptyFn: emptyFn,
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        orderStatusList: '[1301]'
      },
      tableList: [],
      loading: false,
      total: 0,
      // 订单详情
      orderDetilFlag: false,
      row: {},
      // 付款
      fukuanMark: false,
      // fukuanFrom: { ext1: 0 },
      fukuanFrom: {
        ext1: 0,
        oilGasRatio: 0,
        rewardAmount: 0 },
      // 合计
      HJmark: false,
      MXlist: [],
      dialogSF: false,
      SFlist: [],
      isDisable: false, // 导出
      shouruData: {},
      rules: {
        password: { required: true, message: '请输入密码', trigger: 'blur' },
        pricingMethod: { required: true, message: '请选择计价方式', trigger: 'blur' },
        unitPrice: { required: true, message: '请输入单价', trigger: 'blur' },
        reason: { required: true, message: '请输入调价原因', trigger: 'blur' },
        oilGasRatio: { required: true, message: '请输入油气比例', trigger: 'blur' },
        rewardAmount: { required: true, message: '请输入奖励金额', trigger: 'blur' }
      },
      // 调价
      tiaojiaMark: false,
      tiaojiaFrom: {},
      jjfangshi: [
        { val: 1, name: '单价' },
        { val: 2, name: '包干' }
      ],
      jiluMark: false,
      jiluList: [],
      btnFlg: [],
      btnIdArr: ['00JP003B001', '00JP003B002', '00JP003B003', '00JP003B004',
        '00JP003B005', '00JP003B006', '00JP003B007', '00JM030100', '00JM030200', '00JM030300'],
      tuiSongTMark: false,
      tuiSongForm: {},
      dicDataTms: [],
      downstreamSettlementList: [],
      tuiSongLoading: false,
      selectIds: [],
      ids: [],
      businessNo: [],
      businessNos: [],
      zj: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/payPlatform/driver')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  computed: {
    // 实付油气费
    addUp1 () {
      let total1 = 0
      if ((this.fukuanFrom.oilGasRatio || this.fukuanFrom.oilGasRatio == 0) && (this.fukuanFrom.rewardAmount || this.fukuanFrom.rewardAmount == 0)) {
        total1 = parseFloat(total1) + this.fukuanFrom.oilGasRatio == 0 ? this.fukuanFrom.rewardAmount : Number(this.toFixed(parseFloat(this.fukuanFrom.wayAmount) * parseFloat(this.fukuanFrom.oilGasRatio) / 100, 2)) + (this.fukuanFrom.rewardAmount == 0 ? this.fukuanFrom.rewardAmount : parseFloat(this.fukuanFrom.rewardAmount))
      }
      // console.log(total1)
      return total1
    },
    // // 实付运费
    // addUp2 () {
    //   let total1 = 0
    //   if (this.fukuanFrom.oilGasRatio && this.fukuanFrom.rewardAmount) {
    //     total1 = parseFloat(total1) + (parseFloat(this.fukuanFrom.wayAmount) - Number(this.toFixed(parseFloat(this.fukuanFrom.wayAmount) * parseFloat(this.fukuanFrom.oilGasRatio) / 100, 2)))
    //   }
    //   // console.log(total1)
    //   return total1
    // },
    // 实付运费
    addUp2 () {
      let total1 = 0
      if ((this.fukuanFrom.oilGasRatio || this.fukuanFrom.oilGasRatio == 0) && this.fukuanFrom.wayAmount) {
        total1 = parseFloat(total1) + (parseFloat(this.fukuanFrom.wayAmount) - Number(this.toFixed(parseFloat(this.fukuanFrom.wayAmount) * parseFloat(this.fukuanFrom.oilGasRatio) / 100, 2)))
      }
      // console.log(total1)
      return total1
    },
    // 实付合计
    // addUp3 () {
    //   let total1 = 0
    //   if ((this.fukuanFrom.oilGasRatio || this.fukuanFrom.oilGasRatio == 0) && (this.fukuanFrom.rewardAmount || this.fukuanFrom.rewardAmount == 0)) {
    //     console.log('woyao')
    //     total1 = parseFloat(total1) + this.addUp1 + this.addUp2
    //   }
    //   // console.log(total1)
    //   return total1
    // }
    // 实付合计
    addUp3 () {
      let total1 = 0
      if ((this.fukuanFrom.oilGasRatio && this.fukuanFrom.rewardAmount == 0)) {
        console.log('xiangjai ')
        total1 = parseFloat(total1) + Number(this.toFixed(parseFloat(this.fukuanFrom.wayAmount) * parseFloat(this.fukuanFrom.oilGasRatio) / 100, 2)) + (parseFloat(this.fukuanFrom.wayAmount) - Number(this.toFixed(parseFloat(this.fukuanFrom.wayAmount) * parseFloat(this.fukuanFrom.oilGasRatio) / 100, 2)))
      } else if ((this.fukuanFrom.oilGasRatio == 0 && this.fukuanFrom.rewardAmount)) {
        total1 = parseFloat(total1) + parseFloat(this.fukuanFrom.wayAmount) + parseFloat(this.fukuanFrom.rewardAmount)
      } else {
        total1 = parseFloat(total1) + this.addUp1 + this.addUp2
      }
      // console.log(total1)
      return total1
    }
  },
  methods: {
    // 付款
    fukuanFnzz () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 25) {
        this.$alert('最多只能选择25条数据进行操作', '系统提示')
      } else {
        this.ids = []
        this.businessNos = []
        this.zj = []
        let obj = new Map()
        for (let index = 0; index < selectData.length; index++) {
          const item = selectData[index]
          console.log(item, '1')
          if (item.settlementStatus != 1301) { //
            this.$alert('该状态下的数据不能进行付款', '系统提示')
            return
          } else {
            if (index === 0) {
              obj.set(item.orgName, 1)
              this.ids.push(item.id)
              // console.log(this.ids,'this.idsB')
              this.businessNos.push(item.businessNo)
              this.zj.push(item.wayAmount)
            } else {
              if (obj.has(item.orgName)) {
                this.ids.push(item.id)
                // console.log(this.ids,'this.idsC')
                this.businessNos.push(item.businessNo)
                this.zj.push(item.wayAmount)
              } else {
                this.$alert('发布部门不相同数据不能批量进行付款', '系统提示')
                return
              }
            }
          }
        }
        this.fukuanFrom.settlementAccountId = selectData[0].id
        this.fukuanFrom.ids = this.ids.toString()
        piLPaymentList({ ids: this.fukuanFrom.ids }).then(res => {
          this.fukuanFrom.ext1 = res.ext1
          this.fukuanFrom.allTotal = res.allTotal
          this.fukuanMarkzz = true
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error'
          })
        })
      }
    },
    ZFsavezz () {
      if (this.fukuanFrom.allTotal > this.fukuanFrom.ext1) {
        this.$confirm('账户余额不足请充值?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ path: '/payCustomer/recharge' })
        }).catch(() => {

        })
      } else {
        this.$refs.fukuanFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.zfztList = []
            // let data = encryption({
            //   data: { id: this.fukuanFrom.settlementAccountId,
            //     password: this.fukuanFrom.password,
            //     ext1: this.fukuanFrom.ext1,
            //     freightMoney: this.fukuanFrom.allTotal,
            //     oilGasRatio: 0,
            //     oilMoney: '0.00',
            //     rewardAmount: 0,
            //     totalAmount: this.fukuanFrom.allTotal,
            //     wayAmount: this.fukuanFrom.allTotal },
            //   key: this.global.key,
            //   param: ['password']
            // })
            this.digui(loading)
            // downstreamSettlementPayment(data).then(res => {

            // }).catch(error => {
            //   this.$message({
            //     showClose: true,
            //     message: error.message,
            //     type: 'error',
            //     onClose () {
            //       loading.close()
            //     }
            //   })
            // })
          }
        })
      }
    },
    async digui (loading) {
      let _this = this
      console.log(this.ids, 'this.ids')
      for (let i = 0; i < this.ids.length; i++) {
        try {
          let data = encryption({
            data: { id: this.ids[i],
              password: this.fukuanFrom.password,
              ext1: this.fukuanFrom.ext1,
              freightMoney: this.zj[i],
              oilGasRatio: 0,
              oilMoney: '0.00',
              rewardAmount: 0,
              totalAmount: this.zj[i],
              wayAmount: this.zj[i] },
            key: this.global.key,
            param: ['password']
          })
          await downstreamSettlementPayment(data)
          // await downstreamSettlementPayment({ id: this.ids[i] })
          yewu(i, '支付成功', '-')
        } catch (err) {
          yewu(i, '支付失败', err.message)
        }
      }
      function yewu (i, zfzt, msg) {
        // console.log(_this.ids[i],'_this.ids[i]')
        // console.log(_this.businessNos[i],'_this.businessNos[i]')
        _this.zfztList.push({ id: _this.ids[i], businessNo: _this.businessNos[i], zfzt: zfzt, res: msg })
        if (i == _this.ids.length - 1) {
          loading.close()
          _this.fukuanMarkzz = false
          _this.zfztMark = true
          _this.getList(_this.searchFrom)
        }
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.zfzt == '支付成功') {
        return 'chenggong'
      } else {
        return 'shibai'
      }
    },
    cancelReadOnly () {
      this.readonlyInput = false
    },
    oilgasChange () {
      if (this.fukuanFrom.oilGasRatio > 30) {
        this.$alert('油气比例最大不超过30！', '系统提示')
        this.$set(this.fukuanFrom, 'oilGasRatio', '')
      }
    },
    // 圈回
    recallFn (row) {
      this.recallMark = true
      this.recallId = row.id
      console.log(this.recallId)
    },
    recallSave () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      recycleMoney({ id: this.recallId }).then(res => {
        loading.close()
        this.$message({
          message: '圈回成功',
          type: 'success'
        })
        this.recallMark = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 记录
    jiluFn (row) {
      this.unitMeasurement = row.unitMeasurement
      tModifyPriceRecordList({ settlementId: row.id, settlementType: 2 }).then(res => {
        if (res.length > 0) {
          this.jiluMark = true
          this.jiluList = res
          res.forEach((item, index) => {
            this.jiluList[index].tableList = [item]
          })
        } else {
          this.$alert('暂无调价记录', '系统提示')
        }
      })
    },
    // 调价
    tiaojiaFn (row) {
      this.tiaojiaFrom = { ...row }
      this.tiaojiaMark = true
    },
    TJsave () {
      this.$refs.tiaojiaFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          downstreamSettlementPric({
            id: this.tiaojiaFrom.id,
            reason: this.tiaojiaFrom.reason,
            pricingMethod: this.tiaojiaFrom.pricingMethod,
            unitPrice: this.tiaojiaFrom.unitPrice
          }).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.tiaojiaMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 银行回单
    huidanFn (row) {
      chaKanHuiDan(row.businessNo, '', 3)
      // bankReceipt({ platformZxAccNo: row.platformZxAccNo, businessNo: row.businessNo }).then(res => {
      //   let url = this.global.ZXpingzheng + 'subAccNo=' + res.platformZxAccNo + '&printVerifyCode=' + res.printVerifyCode
      //   window.open(url)
      // }).catch(error => {
      //   this.$message({
      //     showClose: true,
      //     message: error.message,
      //     type: 'error',
      //     onClose () {
      //     }
      //   })
      // })
    },
    // // 支付
    // fukuanFn (row) {
    //   toPayDetail({ id: row.id }).then(res => {
    //     this.fukuanFrom.ext1 = res.ext1
    //     this.fukuanMark = true
    //     this.fukuanFrom.totalAmount = row.totalAmount
    //     this.fukuanFrom.id = row.id
    //   })
    // },
    // ZFsave () {
    //   if (this.fukuanFrom.totalAmount > this.fukuanFrom.ext1) {
    //     this.$alert('账户余额不足', '系统提示')
    //   } else {
    //     let data = encryption({
    //       data: this.fukuanFrom,
    //       key: this.global.key,
    //       param: ['password']
    //     })
    //     this.$refs.fukuanFrom.validate((valid) => {
    //       if (valid) {
    //         const loading = this.$loading({
    //           lock: true,
    //           text: '正在处理...'
    //         })
    //         downstreamSettlementPayment(data).then(res => {
    //           loading.close()
    //           this.fukuanMark = false
    //           this.$message({
    //             showClose: true,
    //             message: '操作成功',
    //             type: 'success',
    //             onClose () {
    //               loading.close()
    //             }
    //           })
    //           this.getList(this.searchFrom)
    //         }).catch(error => {
    //           this.$message({
    //             showClose: true,
    //             message: error.message,
    //             duration: 0,
    //             type: 'error',
    //             onClose () {
    //               loading.close()
    //             }
    //           })
    //         })
    //       }
    //     })
    //   }
    // },

    // 支付
    fukuanFn (row, n) {
      if (n == 1) {
        this.ids = []
        this.businessNos = []
        this.zj = []
        if (this.$refs['fukuanFrom']) {
          this.$refs['fukuanFrom'].clearValidate()
        }
        console.log('1')
        toPayDetail({ id: row.id }).then(res => {
          this.fukuanFrom.ext1 = res.ext1
          this.fukuanMark = true
          this.fukuanFrom.totalAmount = row.totalAmount
          this.fukuanFrom.id = row.id
        })
        // console.log(row.id,'row.id')
        // console.log(this.fukuanFrom.id,'this.fukuanFrom.id')
        this.ids.push(row.id)
        this.businessNos.push(row.businessNo)
        this.zj.push(row.wayAmount)
      } else {
        if (this.$refs['fukuanFrom']) {
          this.$refs['fukuanFrom'].clearValidate()
        }
        console.log('2')
        toPayDetail({ id: row.id }).then(res => {
          this.fukuanFrom.ext1 = res.ext1
          this.oilgasMark = true
          this.fukuanFrom.wayAmount = row.totalAmount
          this.fukuanFrom.id = row.id
        })
        // getAccCashList().then(res => {
        //   this.balance = res
        // })
        this.ids.push(row.id)
        this.businessNos.push(row.businessNo)
        this.zj.push(row.wayAmount)
      }
    },
    ZFsave () {
      if (this.fukuanFrom.totalAmount > this.fukuanFrom.ext1) {
        this.$alert('账户余额不足', '系统提示')
      } else {
        let data = encryption({
          data: this.fukuanFrom,
          key: this.global.key,
          param: ['password']
        })
        // if (this.fukuanFrom.oilGasRatio == 0 && this.fukuanFrom.rewardAmount == 0) {
        //   console.log(11)
        //   delete this.fukuanFrom.oilGasRatio
        //   delete this.fukuanFrom.rewardAmount
        //   console.log(this.fukuanFrom)
        // }

        this.$refs.fukuanFrom.validate((valid) => {
          if (valid) {
            console.log(data)
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            downstreamSettlementPayment(data).then(res => {
              loading.close()
              this.fukuanMark = false

              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
                onClose () {
                  loading.close()
                }
              })
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                duration: 0,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    oilgassave () {
      if (this.addUp1 > this.balance) {
        this.$alert('油气余额不足', '系统提示')
        return
      }
      if (this.addUp2 > this.fukuanFrom.ext1) {
        this.$alert('运费账户余额不足', '系统提示')
        return
      }
      if (this.addUp1 || this.addUp1 == 0) {
        this.$set(this.fukuanFrom, 'oilMoney', Number(this.addUp1).toFixed(2))
      }
      if (this.addUp2 || this.addUp2 == 0) {
        this.$set(this.fukuanFrom, 'freightMoney', Number(this.addUp2).toFixed(2))
      }
      if (this.addUp3 || this.addUp3 == 0) {
        this.$set(this.fukuanFrom, 'totalAmount', Number(this.addUp3).toFixed(2))
      }

      let data = encryption({
        data: this.fukuanFrom,
        key: this.global.key,
        param: ['password']
      })
      this.$refs.fukuanFrom.validate((valid) => {
        if (valid) {
          console.log(data)
          console.log('shuchu')
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          downstreamSettlementPayment(data).then(res => {
            loading.close()
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
              onClose () {
                loading.close()
              }
            })
            this.oilgasMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              duration: 0,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // // 应付合计
    // YFHJfn (row) {
    //   downstreamSettlementDetail({ businessNo: row.businessNo }).then(res => {
    //     this.HJmark = true
    //     this.fukuanFrom.totalAmount = row.totalAmount
    //     this.MXlist = res.list
    //   })
    // },
    // 应付合计
    YFHJfn (row) {
      downstreamSettlementDetail({ id: row.id }).then(res => {
        this.$set(this, 'jiesuanID', row.id)
        this.HJmark = true
        this.fukuanFrom.totalAmount = res.total
        this.MXlist = res.list.filter(item => item.feeType != 4)
      })
    },
    shuifeiFn (row) {
      sTaxationDetail({ businessNo: row.businessNo }).then(res => {
        this.dialogSF = true
        this.SFlist = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    oliFeeFn (row) {
      oilDetailList({ id: this.jiesuanID }).then(res => {
        this.dialogOli = true
        this.oliList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // 导出
    exportFn () {
      if (this.searchFrom.settlementStatusS == '[1304,1305]') {
        this.searchFrom.settlementStatusList = '[1304,1305,1306,1307]'
        this.searchFrom.settlementStatus = ''
      } else {
        this.searchFrom.settlementStatus = this.searchFrom.settlementStatusS
        this.searchFrom.settlementStatusList = ''
      }
      let form = this.searchFrom
      exportExcel(
        this.global.payServer + '/downstreamSettlement/exportList',
        form,
        '支出结算列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 订单详情
    seeClickNO (row) {
      this.row = row
      this.orderDetilFlag = true
    },
    destroy () {
      this.orderDetilFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.businessNoss) { this.searchFrom.businessNos = this.searchFrom.businessNoss.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.businessNos = ''
      }
      if (this.searchFrom.orderNoss) { this.searchFrom.orderNos = this.searchFrom.orderNoss.split(/[(\r\n)\r\n]+/) } else {
        this.searchFrom.orderNos = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      if (this.searchFrom.settlementStatusS == '[1304,1305]') {
        this.searchFrom.settlementStatusList = '[1304,1305,1306,1307]'
        this.searchFrom.settlementStatus = ''
      } else {
        this.searchFrom.settlementStatus = this.searchFrom.settlementStatusS
        this.searchFrom.settlementStatusList = ''
      }
      this.loading = true
      downstreamSettlementList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.shouruData.total = res.map.allTotal
        this.shouruData.wTotal = res.map.wTotal
        this.shouruData.alreadytotal = res.map.alreadytotal
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        orderStatusList: '[1201,1202,1203]',
        carriageType: 1,
        type: 2,
        receiveStatus: 1,
        appointType: 1,
        tPlusId: ''
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
      // this.fukuanFrom = {}
      this.fukuanFrom = {
        oilGasRatio: 0,
        rewardAmount: 0,
        ext1: 0
      }
    },
    // 获取row的key值，其中row.id为每行记录的唯一标识
    // getRowKeys (row) {
    //   // console.log(row.id, 'row.id')
    //   return row.id
    // },
    // 点击推送T+
    tuiSong () {
      const selectData = this.$refs.table.selection
      console.log(selectData, 'selectData')
      // 必须是已提现withdrawalStatus = 3 并且收款方settlementCode、settlementType必须一致   withdrawalTime提现时间必须一致
      let settlementCodeArr = []
      let settlementTypeArr = []
      let withdrawalStatusArr = []
      let tPlusIdArr = []
      let withdrawalTimeArr = []
      selectData.forEach((item, index) => {
        settlementCodeArr.push(item.settlementCode)
        settlementTypeArr.push(item.settlementType)
        withdrawalStatusArr.push(item.withdrawalStatus)
        tPlusIdArr.push(item.tPlusId)
        withdrawalTimeArr.push(this.timeStamp(item.withdrawalTime))
      })
      // console.log(withdrawalTimeArr,'withdrawalTimeArr')
      let flagA = withdrawalStatusArr.every(item => item == 3)
      let flagB = tPlusIdArr.every(item => item == null)
      console.log(flagB, 'flagB')
      // tPlusId有值已推送  null未推送
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (!flagA) {
        this.$alert('只能选择已提现的数据', '系统提示')
      } else if (!this.isAllEqual(settlementCodeArr)) {
        this.$alert('收款方必须一致', '系统提示')
      } else if (!this.isAllEqual(settlementTypeArr)) {
        this.$alert('收款方必须一致', '系统提示')
      } else if (!this.isAllEqual(withdrawalTimeArr)) {
        this.$alert('只能选择同一天提现数据', '系统提示')
      } else if (selectData.length > 100) {
        this.$alert('最多只能选择100条数据进行操作', '系统提示')
      } else {
        this.tuiSongTMark = true
        this.getDicFromTms()
        this.downstreamSettlementList = selectData
      }
    },
    tuiSongSubmit () {
      this.tuiSongLoading = true
      this.selectIds = []
      this.downstreamSettlementList.forEach((item, index) => {
        this.selectIds.push(item.id)
      })
      pushTPlusToTmsPay({
        itemNo: this.tuiSongForm.itemNo, // （取“getDicFromTms”接口返回的itemNo对应的值）
        downstreamSettlementList: this.selectIds.toString() // 下游结算单对象
      }).then(res => {
        this.tuiSongLoading = false
        this.$message.success('成功')
        this.tuiSongTMark = false
        this.getList(this.searchFrom)
        this.tuiSongForm.itemNo = ''
      }).catch(error => {
        this.tuiSongLoading = false
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
      })
    },
    tuiSongQuXiao () {
      this.tuiSongTMark = false
      this.tuiSongForm.itemNo = ''
    },
    getDicFromTms () {
      getDicFromTms({
        dictionaryType: 'yongyou_push_t'
      }).then(res => {
        // console.log(res, 'res')
        this.dicDataTms = res
      })
    },
    isAllEqual (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== array[0]
        })
      } else {
        return true
      }
    },
    timeStamp (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    }
  },
  watch: {
    tiaojiaFrom: {
      handler (newName, oldName) {
        if (this.tiaojiaFrom.pricingMethod == 1) {
          if (this.tiaojiaFrom.weight && this.tiaojiaFrom.unitPrice) {
            this.tiaojiaFrom.totalAmount = this.toFixed(accMul(this.tiaojiaFrom.weight, this.tiaojiaFrom.unitPrice), 2)
          } else {
            this.$set(this.tiaojiaFrom, 'totalAmount', 0)
          }
        } else if (this.tiaojiaFrom.pricingMethod == 2) {
          if (this.tiaojiaFrom.unitPrice) {
            this.tiaojiaFrom.totalAmount = this.tiaojiaFrom.unitPrice
          }
        }

        function accMul (arg1, arg2) {
          var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
          try {
            m += s1.split('.')[1].length
          } catch (e) {
          }
          try {
            m += s2.split('.')[1].length
          } catch (e) {
          }

          return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
        }
      },
      deep: true
      // immediate: true
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
.jiage .el-form-item__content {
  position: relative;
  .danwei1 {
    position: absolute;
    right: 4px;
    color: #9c9797;
    padding: 0px 4px;
  }
}
/deep/.el-divider--horizontal{
  margin-top: 14px;
}
/deep/.el-table .chenggong {
   background: #9bd67e !important;
}
/deep/.el-table .shibai {
   background: #f59191 !important;
}
</style>
